import {
  DateTimePicker,
  type DateTimePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { type Theme, ThemeProvider, createTheme } from "@mui/material/styles";
import { forwardRef } from "react";

export type DateTimePickerInputProps = DateTimePickerProps & {
  fullWidth?: boolean;
  helperText?: string;
  error?: boolean;
  errorText?: string;
  required?: boolean;
};

export const DateTimePickerInput = forwardRef<any, DateTimePickerInputProps>(
  (
    {
      error = false,
      errorText = "",
      helperText = "",
      fullWidth = true,
      required = false,
      label,
      ...rest
    },
    ref
  ) => {
    const userTheme = (theme: Theme) =>
      createTheme({
        ...theme,
        components: {
          ...theme.components,
          MuiPaper: {}, // Resets Paper props so background isn't grey in light mode
        },
      });

    return (
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <ThemeProvider theme={userTheme}>
          <DateTimePicker
            {...rest}
            inputRef={ref}
            label={label}
            slotProps={{
              ...rest.slotProps,
              textField: {
                ...rest.slotProps?.textField,
                fullWidth,
                helperText: errorText || helperText,
                error,
                required,
              },
            }}
          />
        </ThemeProvider>
      </LocalizationProvider>
    );
  }
);
